<template>
    <div class="login-wrap" v-if="!isMobile">
        <div class="login-wrap__logo">
            <img class="logo-img" src="@/assets/img/logo.svg" alt="智能体开发平台" />
            <img class="logo-split" src="@/assets/img/vector.svg" alt="split" />
            <div class="logo-txt">智能体开发平台</div>
        </div>
        <div class="login-wrap__main">
            <div class="login-wrap__main-left">
                <img class="banner-img" src="@/assets/img/loginBg.png" />
            </div>
            <div class="login-wrap__main-right">
                <LoginForm />
            </div>
        </div>
    </div>

    <div class="login-wrap-mobile" v-else>
        <div class="login-wrap-mobile__header">
            <img class="banner-img" src="@/assets/img/loginBgMobile.png" />
            <div class="login-wrap-mobile__logo">
                <img
                    class="logo-img"
                    src="@/assets/img/logo.svg"
                    alt="智能体开发平台"
                />
                <img class="logo-split" src="@/assets/img/vector.svg" alt="split" />
                <div class="logo-txt">智能体开发平台</div>
            </div>
        </div>
        <div class="login-wrap-mobile__main">
            <LoginForm />
        </div>
    </div>
</template>

<script>
import { getQueryVariable } from '@/utils';
import LoginForm from './LoginForm.vue';

export default {
    name: 'Login',
    data () {
        return {};
    },
    components: {
        LoginForm
    },
    created () {
        const userName = localStorage.getItem('user_name');
        if (!userName) {
            return;
        }
        const redirectUrl = decodeURIComponent(getQueryVariable('redirect_url'));
        console.log('redirectUrl  redirectUrl redirectUrl', redirectUrl);
        if (redirectUrl) {
            window.location.href = redirectUrl;
            window.location.reload();
        } else {
            const { protocol, host, pathname } = window.location;
            window.location.href = `${protocol}//${host}${pathname}#/`;
            window.location.reload();
        }
    }
};
</script>

<style lang="less" scoped>
.login-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: hidden;
  min-width: 1220px;

  &__logo {
    position: absolute;
    top: 50px;
    left: 50px;
    display: flex;
    align-items: center;
    flex-flow: row nowrap;

    .logo-img {
      height: 24px;
    }
    .logo-split {
      width: 2px;
      height: 12px;
      fill: var(--color-divider-normal);
      margin: 0 11px;
    }
    .logo-txt {
      color: var(--color-text-primary);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }

  &__main {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    width: 100%;
    height: 100%;

    &-left {
      background: linear-gradient(
        180deg,
        #eaeef6 0%,
        rgba(234, 238, 246, 0.2) 100%
      );

      .banner-img {
        // width: 520px;
        // max-width: 520px;
        height: 100vh;
      }
    }

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
}

.login-wrap-mobile {
  height: 100%;
  overflow: hidden;
  padding: 0;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    width: 100%;
    height: 180px;
    align-self: center;

    .banner-img {
      width: 100%;
      height: auto;
    }
  }
  &__logo {
    position: absolute;
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    .logo-img {
      height: 24px;
    }
    .logo-split {
      width: 2px;
      height: 12px;
      fill: var(--color-divider-normal);
      margin: 0 11px;
    }
    .logo-txt {
      color: var(--color-text-primary);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }
  &__main {
    margin-top: -47px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/main.vue